import UserAvatar from "../ui/UserAvatar";

// Chat-sized wrapper around the shared UserAvatar (photo or initials, optional presence dot).
function ChatAvatar({ name, src, seed = 0, size = "md", online, group = false }) {
  return <UserAvatar name={name} src={src} seed={seed} size={size} online={online} group={group} />;
}

export default ChatAvatar;
